import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Icon } from 'antd'
import FoldersSliderHolder, { PAGE_PADDING } from '../styles/foldersSliderStyle'

const CARD_MIN_WIDTH = 220
const CARD_GAP = 12
const ROWS = 2

const FoldersSlider = ({ items = [], renderItem, resetKey }) => {
  const viewportRef = useRef(null)
  const columnsRef = useRef(4)
  const [columns, setColumns] = useState(4)
  const [page, setPage] = useState(0)

  useEffect(() => {
    const node = viewportRef.current
    if (!node) return
    const observer = new ResizeObserver(([entry]) => {
      const width = entry.contentRect.width - PAGE_PADDING * 2
      const next = Math.max(1, Math.floor((width + CARD_GAP) / (CARD_MIN_WIDTH + CARD_GAP)))
      const prev = columnsRef.current
      if (next === prev) return
      columnsRef.current = next
      setPage((p) => Math.floor((p * prev * ROWS) / (next * ROWS)))
      setColumns(next)
    })
    observer.observe(node)
    return () => observer.disconnect()
  }, [])

  const [lastResetKey, setLastResetKey] = useState(resetKey)
  if (lastResetKey !== resetKey) {
    setLastResetKey(resetKey)
    setPage(0)
  }

  const pages = useMemo(() => {
    const size = columns * ROWS
    const result = []
    for (let i = 0; i < items.length; i += size) result.push(items.slice(i, i + size))
    return result
  }, [items, columns])

  const lastPage = Math.max(0, pages.length - 1)
  const current = Math.min(page, lastPage)

  useEffect(() => {
    if (page > lastPage) setPage(lastPage)
  }, [page, lastPage])

  return (
    <FoldersSliderHolder>
      <div className="folders-slider-viewport" ref={viewportRef}>
        <div key={String(resetKey)} className="folders-slider-track" style={{ transform: `translateX(-${current * 100}%)` }}>
          {pages.map((pageItems, index) => (
            <div
              key={index}
              className="folders-slider-page"
              aria-hidden={index !== current}
              style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
            >
              {pageItems.map(renderItem)}
            </div>
          ))}
        </div>
      </div>
      {current > 0 && (
        <button type="button" className="folders-slider-arrow prev" onClick={() => setPage(current - 1)}>
          <Icon type="left" />
        </button>
      )}
      {current < lastPage && (
        <button type="button" className="folders-slider-arrow next" onClick={() => setPage(current + 1)}>
          <Icon type="right" />
        </button>
      )}
    </FoldersSliderHolder>
  )
}

export default FoldersSlider
